import { takeLatest, call, put } from 'redux-saga/effects';
import { postPatientMedicalHistorySuccess, postPatientMedicalHistoryFailure, putPatientMedicalHistorySuccess, putPatientMedicalHistoryFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
import { updatePatientImagingAttachement } from '../../../../utils/api';


function* postPatientMedicalHistoryRequest(action) {
    try {
        const response = yield call(apiPost, 'api/post-patient-medical-history', action.payload);
        if (response.success) {
            const fileUploadRes = yield call(updatePatientImagingAttachement, action.payload.fileFormData, action.payload.pId);
            if (fileUploadRes?.data?.imagingStudies) {
                response.imagingStudies = fileUploadRes?.data?.imagingStudies
            } else if (fileUploadRes?.success === false && action.payload.fileFormData?.has('imagingStudies')) {
                // The history saved but the server rejected the files (e.g.
                // wrong type). Say so instead of showing a plain success.
                yield put(postPatientMedicalHistoryFailure(`Medical history saved, but the files were not uploaded. ${fileUploadRes.message || ''}`.trim()));
                return;
            }
        }
        yield put(postPatientMedicalHistorySuccess(response));
    } catch (error) {
        yield put(postPatientMedicalHistoryFailure(error?.response?.message || error));
    }
}


function* putPatientMedicalHistoryRequest(action) {
    try {
        const response = yield call(apiPut, `api/edit-patient-medical-history/${action.payload._id}`, action.payload.formData);
        yield put(putPatientMedicalHistorySuccess(response));
    } catch (error) {
        yield put(putPatientMedicalHistoryFailure(error?.response?.message || error));
    }
}


function* saga() {
    yield takeLatest('patientMedicalHistory/postPatientMedicalHistoryRequest', postPatientMedicalHistoryRequest);
    yield takeLatest('patientMedicalHistory/putPatientMedicalHistoryRequest', putPatientMedicalHistoryRequest);
}

export default saga;